// NOTE: this uses DOM mutation to modify the toolbar template in confluence atlassian-editor.vm

import { bind, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { domBind, domTrigger } from '../../lib/dom-event';
import window from 'window-or-global';

// eslint-disable-next-line no-restricted-syntax, @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import '../../adg3-styles/editor-content.css';
import { logAnalytics } from '../editor-analytics/analytics';

const addLogo = () => {
	const toolbar = getToolbar();
	toolbar.insertAdjacentHTML(
		'afterbegin',
		`
        <ul class="aui-buttons">
            ## ADG3 editor logo
            <li id="adg3-charlie-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="10 9 20 21" version="1.1">
                    <defs>
                        <linearGradient x1="87.3894879%" y1="99.2165215%" x2="35.1317389%" y2="39.2162895%" id="linearGradient-1">
                            <stop stop-color="#A5ADBA" offset="0%"/>
                            <stop stop-color="#C1C7D0" offset="100%"/>
                        </linearGradient>
                        <linearGradient x1="14.1838118%" y1="5.80047897%" x2="61.141783%" y2="70.9663868%" id="linearGradient-2">
                            <stop stop-color="#A5ADBA" offset="0%"/>
                            <stop stop-color="#C1C7D0" offset="100%"/>
                        </linearGradient>
                    </defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="confluence-light" fill-rule="nonzero">
                            <path d="M10.0679208,24.8931748 C9.85301417,25.243638 9.61165744,25.6503075 9.40666954,25.9743206 C9.22318946,26.2843791 9.32168891,26.6842575 9.62818873,26.8736224 L13.9263221,29.5186276 C14.0771954,29.6117793 14.2591589,29.6404355 14.4313594,29.5981625 C14.6035598,29.5558895 14.7515684,29.4462293 14.8421552,29.2938021 C15.0140805,29.0061578 15.2355997,28.6325508 15.4769564,28.2324938 C17.1796785,25.4221758 18.8923193,25.7660265 21.9803628,27.2406169 L26.2421274,29.2673521 C26.4035355,29.3441777 26.5891716,29.3523812 26.7567273,29.2900928 C26.924283,29.2278045 27.0594818,29.1003316 27.1315104,28.9367264 L29.1780831,24.3079674 C29.3226768,23.9773763 29.1755503,23.5919046 28.8474575,23.4417282 C27.9481557,23.0185274 26.159471,22.175432 24.5493241,21.3984617 C18.7567628,18.5881437 13.8337469,18.7732941 10.0679208,24.8931748 Z" id="Shape" fill="url(#linearGradient-1)"/><path d="M29.3400897,14.0618786 C29.5549964,13.7114154 29.7963531,13.3047459 30.001341,12.9807328 C30.1848211,12.6706743 30.0863216,12.2707959 29.7798218,12.081431 L25.4816884,9.43642585 C25.3287553,9.33452192 25.1403124,9.30085833 24.961556,9.343509 C24.7827995,9.38615966 24.6298552,9.50127703 24.5394053,9.66125129 C24.36748,9.9488956 24.1459608,10.3225026 23.9046041,10.7225596 C22.201882,13.5328776 20.4892412,13.1890269 17.4011977,11.7144365 L13.1526581,9.6910076 C12.99125,9.61418193 12.805614,9.60597847 12.6380582,9.66826684 C12.4705025,9.73055522 12.3353038,9.85802811 12.2632751,10.0216332 L10.2167024,14.6503923 C10.0721087,14.9809834 10.2192353,15.366455 10.547328,15.5166315 C11.4466298,15.9398323 13.2353145,16.7829277 14.8454614,17.559898 C20.6512477,20.3669097 25.5742636,20.1817593 29.3400897,14.0618786 Z" id="Shape" fill="url(#linearGradient-2)"/>
                        </g>
                    </g>
                </svg>
            </li>
        </ul>
    `,
	);
	window.document.querySelector('#adg3-charlie-icon').addEventListener('click', () => {
		logAnalytics('ADG3-Editor-Atlas-Logo-Clicked');
	});
};

export const removeElement = (el) => {
	if (el) {
		// normalise for IE removeNode method
		if (el.remove) {
			el.remove();
		} else {
			el.removeNode(true);
		}
	}
};

const removeButtons = (selectors) => {
	selectors.forEach((selector) => {
		const btn = window.document.querySelector(selector);
		removeElement(btn);
	});
};

const getToolbar = () => {
	return window.document.querySelector('#rte-toolbar .toolbar-primary');
};

const addADG3ContentStyles = (editor) => {
	const body = editor.getBody();
	body.classList.add('adg3-editor');
};

export const moveSynchronyAvatar = () => {
	const secondaryToolbar = window.document.querySelector('div.aui-toolbar2-secondary');
	const avatars = window.document.querySelector('ul#avatar-list');
	const avatarsPlus = window.document.querySelector('#synchrony-presence-overlay');

	if (secondaryToolbar && avatars && avatarsPlus) {
		secondaryToolbar.appendChild(avatars);
		secondaryToolbar.appendChild(avatarsPlus);
	}
};

/**
 * Create a container as a placeholder for button InviteToEdit
 * The button is created and appended to this container by confluence-invite-to-edit-plugin
 */
const createContainerForInviteToEdit = () => {
	// aui-toolbar2-secondary
	const secondaryToolbar = window.document.querySelector('div.aui-toolbar2-secondary');
	if (secondaryToolbar) {
		const adg3Wrapper = window.document.createElement('div');
		adg3Wrapper.classList.add('adg3InviteToEdit');
		secondaryToolbar.appendChild(adg3Wrapper);
	}
};

const renameParagraph = () => {
	// TODO: need a more robust way todo this
	// since the menu is dynamically generated, we will need to change in the menu code
	// change the block dropdown menu name from paragraph to Normal Text
	// const nuText = editor.translate('tinymce.formatting.paragraph');
	// const menuItem = document.querySelector('#format-dropdown-display .dropdown-text');
	// if (menuItem && nuText) {
	//     menuItem.innerText = nuText;
	// }
};

/**
 * CONFDEV-57521
 * We are not using this function, but wanna keep it here in case we change our mind
 */
export const changeListOrder = () => {
	// ensure Numlist button is before Bullet list in the toolbar
	const ulButton = window.document.querySelector('#rte-button-bullist');
	const olButton = window.document.querySelector('#rte-button-numlist');
	const listGroup = window.document.querySelector(
		'#rte-toolbar .aui-buttons.rte-toolbar-group-lists',
	);

	if (listGroup && olButton && ulButton) {
		listGroup.insertBefore(olButton, ulButton);
	}
};

/**
 * CONFDEV-57521
 * We are not using this function, but wanna keep it here in case we change our mind
 */
export const moveFontColorButton = () => {
	// move the font color button before the Underline and after Italic
	const fontButton = window.document.querySelector('#color-picker-control');
	const underlineButton = window.document.querySelector('#rte-button-underline');
	const styleGroup = window.document.querySelector('UL.aui-buttons.rte-toolbar-group-style');

	if (fontButton && underlineButton && styleGroup) {
		styleGroup.insertBefore(fontButton, underlineButton);
	}
};

const mutuallyExclusiveToolbars = (editor) => {
	/*
        TODO: bind keyboard shortcuts to these methods, onSearch, onTable, onPagelayout
        otherwise the behaviour will be different on shortcuts.
    */
	const pageLayoutButton = window.document.querySelector('#rte-button-pagelayout-2');
	const searchButton = window.document.querySelector('#rte-button-searchreplace');

	const closePageLayout = () => {
		pageLayoutButton.classList.remove('active');
		domTrigger(window.document, 'disableContextToolbarRow.Toolbar', {
			id: 'pl2-toolbar',
		});
	};

	const closeTableToolbar = () => {
		domTrigger(window.document, 'disableContextToolbarRow.Toolbar', {
			id: 'default',
		});
	};

	const closeSearchToolbar = () => {
		if (isOpen(searchButton)) {
			editor.execCommand('mceSearchReplaceToolbar');
		}
	};

	const onSearch = () => {
		closePageLayout();
		closeTableToolbar();
	};

	const onTable = (e, options) => {
		if (options && options.id && options.id === 'default') {
			closePageLayout();
			closeSearchToolbar();
		}
	};

	const onPagelayout = () => {
		closeTableToolbar();
		closeSearchToolbar();
	};

	const isOpen = (element) => {
		return element.classList.contains('active');
	};

	pageLayoutButton.addEventListener('click', onPagelayout);
	searchButton.addEventListener('click', onSearch);
	domBind(window.document, 'enableContextToolbarRow.Toolbar', onTable);
};

const bindHelpOnDisable = () => {
	const helpBtn = window.document.querySelector('.toolbar-trigger[data-control-id=help]');
	domBind(helpBtn, 'click', function () {
		if (this.parentElement.classList.contains('disabled')) {
			window.Confluence.KeyboardShortcuts.openDialog();
		}
	});
};

const getPageEditor = () => {
	return window.document.querySelector('#content.edit');
};

const getCommentEditor = () => {
	return window.document.querySelector('.editor-container');
};

export const decorateUi = () => {
	const pageEditor = getPageEditor();
	const container = pageEditor || getCommentEditor();
	container.classList.add('adg3-editor');
	if (pageEditor) {
		window.document.body.classList.add('adg3-editor');
	}
};

const applyAdg3 = () => {
	const editor = window.tinymce.activeEditor;
	addADG3ContentStyles(editor);
	renameParagraph(editor);
	moveSynchronyAvatar();
	addLogo();
	mutuallyExclusiveToolbars(editor);
	bindHelpOnDisable();
	createContainerForInviteToEdit();
	removeButtons([
		'#rte-toolbar #macro-insert-list .dropdown-item.macro-gallery', // Gallery macro
	]);
};

export const pluginDefinition = () => {
	return {
		init() {
			unbind('rte-ready', applyAdg3);
			bind('rte-ready', applyAdg3);
		},
		getInfo() {
			return {
				longname: 'Adg3 Themed Editor',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				infourl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
};

export default () => {
	window.tinymce.create('tinymce.plugins.Adg3Editor', pluginDefinition());
	window.tinymce.PluginManager.add('Adg3Editor', window.tinymce.plugins.Adg3Editor);
};
